import axios from "axios";
import Vue from "vue";

const token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
  axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
} else {
  console.error("CSRF token not found");
}

Vue.prototype.$http = axios;



// WEBPACK FOOTER //
// app/javascript/shared/requests.js